import { useSelector } from 'react-redux'
import { IAuthState, IPersonalUserData } from './types'
import { TVTVPACI } from 'settings/_profileSettings'


export const usePersonalUserData = (): IPersonalUserData => {
  const userData = useSelector((state: IAuthState) => state?.auth?.userData)
  const userEmail = useSelector((state: IAuthState) => state?.auth?.userData?.person_general?.email)
  const planSelected = useSelector((state: IAuthState) => state?.auth?.profileSelected?.plans.find(pPlan => pPlan.default === true))

  const userPlanCode = planSelected?.plan_group?.code
  const userProfile = userData?.person_profile?.find(profile => profile.profile_code === TVTVPACI)
  const userRole = userProfile?.profile_code === TVTVPACI ? 'PACI' : null

  return { 
    userEmail,
    userPlanCode,
    userRole,
  }
}